import http from 'utils/http';
import type { ServiceId } from 'interface/service';

import { EMPLOYEE_ASSETS } from 'constants/endpoints';
import { interpolate } from 'utils/string';

export async function fetchAssetsById(id: ServiceId) {
  const { data } = await http.get(interpolate(EMPLOYEE_ASSETS, { id }));
  return data;
}
